function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var generatePokusAssignVariantBodyRequest = function generatePokusAssignVariantBodyRequest(_ref) {
  var lob = _ref.lob,
      isMobile = _ref.isMobile,
      deviceId = _ref.deviceId,
      _ref$extraOptions = _ref.extraOptions,
      extraOptions = _ref$extraOptions === void 0 ? {} : _ref$extraOptions;
  var device = isMobile ? 'mobile' : 'desktop';
  var request = {
    lob: lob,
    user: _extends({
      deviceId: deviceId
    }, extraOptions.user),
    attributes: _extends({
      device_os: device,
      device_type: device
    }, extraOptions.attributes)
  };
  return {
    request: request
  };
};

var generateSkywalkerBodyRequest = function generateSkywalkerBodyRequest(_ref) {
  var extraReqBody = _ref.extraReqBody;

  var request = _extends({
    brand: 'gi',
    user: {
      loginChannel: 'GI'
    }
  }, extraReqBody);

  return request;
};

/**
 *
 * @docs http://confluence.mmt.com/pages/viewpage.action?pageId=823704867
 */
var generatePokusDynamicConfigBodyRequest = function generatePokusDynamicConfigBodyRequest(_ref) {
  var lob = _ref.lob,
      isMobile = _ref.isMobile,
      deviceId = _ref.deviceId,
      _ref$extraOptions = _ref.extraOptions,
      extraOptions = _ref$extraOptions === void 0 ? {} : _ref$extraOptions;
  var device = isMobile ? 'mobile' : 'desktop';
  var request = {
    lob: lob,
    user: _extends({
      deviceId: deviceId
    }, extraOptions.user),
    attributes: _extends({
      device_os: device,
      device_type: device
    }, extraOptions.attributes),
    scope: {
      lob: lob,
      deviceOS: device.toUpperCase() // scope values must be in uppercase

    }
  };
  var propertiesToAssign = ['productFeatureConfigKeys', 'features', 'applicationProperties', 'experimentIds'];
  propertiesToAssign.forEach(function (property) {
    if (extraOptions[property]) {
      request[property] = extraOptions[property];
    }
  });
  return request;
};

export { _extends as _, generateSkywalkerBodyRequest as a, generatePokusDynamicConfigBodyRequest as b, generatePokusAssignVariantBodyRequest as g };
